import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { LoginComponent } from './components/login/login.component';
import { OtpLoginComponent } from './components/otp-login/otp-login.component';
import { RecuperaPasswordComponent } from './components/recupera-password/recupera-password.component';
import { AuthguardService } from './services/authguard.service';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/login'
  },
  {
    path: 'home',
    loadChildren: () => import('./components/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'management-users',
    loadChildren: () => import('./components/gestione-utenti/gestione-utenti.module').then(m => m.GestioneUtentiModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'customer-data-entry',
    loadChildren: () => import('./components/customer-data-entry/customer-data-entry.module').then(m => m.CustomerDataEntryModule),
    canActivate: [AuthguardService]
  },
  //{
    //path: 'wizard-create-custom',
    //loadChildren: () => import('./components/customer-data-entry/creazione/wizard-create-customer/wizard-create-customer.module').then(m => m.WizardCreateCustomerModule),
    //canActivate: [AuthguardService]
  //},
  //{
    //path: 'wizard-update-custom',
    //loadChildren: () => import('./components/customer-data-entry/creazione/wizard-update-customer/wizard-update-customer.module').then(m => m.WizardUpdateCustomerModule),
    //canActivate: [AuthguardService]
  //},
  {
    path: 'create-customer',
    loadChildren: () => import('./components/customer-data-entry/save/creazione-nuovo-customer/creazione-nuovo-customer.module').then(m => m.CreazioneNuovoCustomerModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'update-customer/:id',
    loadChildren: () => import('./components/customer-data-entry/save/modifica-customer/modifica-customer.module').then(m => m.ModificaCustomerModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'local-agreements-view',
    loadChildren: () => import('./components/local-agreements/local-agreements-view/local-agreements-view.module').then(m => m.LocalAgreementsViewModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'catalog-view',
    loadChildren: () => import('./components/catalog-view/catalog-view.module').then(m => m.CatalogViewModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'handset-view/:idCatalog',
    loadChildren: () => import('./components/catalog-view/handset-view/handset-view.module').then(m => m.HandsetViewModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'tariff-and-option-view/:idCatalog',
    loadChildren: () => import('./components/catalog-view/tariff-and-option-view/tariff-and-option-view.module').then(m => m.TariffAndOptionViewModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'bundled-product-offering-view/:idCatalog/:idProduct/:idCategory',
    loadChildren: () => import('./components/catalog-view/bundled-product-offering-view/bundled-product-offering-view.module').then(m => m.BundledProductOfferingViewModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'inventory-view',
    loadChildren: () => import('./components/inventory-view/inventory-view.module').then(m => m.InventoryViewModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'product-relationship-view/:idProduct',
    loadChildren: () => import('./components/inventory-view/product-relation-ship-view/product-relation-ship-view.module').then(m => m.ProductRelationShipViewModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'reporting-view',
    loadChildren: () => import('./components/reporting-view/reporting-view.module').then(m => m.ReportingViewModule),
    canActivate: [AuthguardService]
  },
  {
    path: 'otpLogin',
    component: OtpLoginComponent,
  },
  {
    path: 'recoveryPassword',
    component: RecuperaPasswordComponent,
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent
  },
  {
    path: 'fwp',
    loadChildren: () => import('./FASWhiteLabelPortal/pages/fwp/fwp.module').then(m => m.FwpModule),
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
